import httpClient from '@/http-client'

export const dailyTimescan = data => {
	return httpClient
		.get('/api/report/employee-daily-timescans', data)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const department = (Options = {}) => {
	return httpClient
		.get('/api/report/employee-daily-timescans/departments', Options)
		.then(response => Promise.resolve(response.data))
		.catch(error => Promise.reject(error.response.data))
}

export const dailyTimescanExcel = data => {
	return httpClient
		.post('/api/report/employee-daily-timescans/excels', data, {
			responseType: 'arraybuffer'
		})
		.then(response => Promise.resolve(response))
		.catch(error => Promise.reject(error.response.data))
}

export default { dailyTimescan, department, dailyTimescanExcel }
